module.exports = __webpack_public_path__ + "img/ball_9_black.43631c98.png";